export default __webpack_public_path__ + "assets/home-one-two.ed1457e840e2a21815f490914f77549d.png";